import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { MsalInterceptor } from '@azure/msal-angular';
import { CleanfillApiModule } from '@services/cleanfill-api/cleanfill-api.module';
import { GlobalErrorHandler } from './global-error.handler';
import { HttpErrorInterceptor } from './http-error.interceptor';
import { TimeZoneInterceptor } from './time-zone.interceptor';
import { NgxPermissionsModule } from 'ngx-permissions';
@NgModule({
  imports: [HttpClientModule, CleanfillApiModule, NgxPermissionsModule.forRoot()],
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TimeZoneInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true }
  ]
})
export class CoreModule {}
